import { createContext, useContext, useState, useEffect } from 'react';
import AssetsImageAPI from '~/api/assetsImageApi';

const AssetsImageContext = createContext();

export function AssetsImageProvider({ children }) {
    const [assetsImage, setAssetsImage] = useState([])
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        AssetsImageAPI.getAll().then(res => {
            setAssetsImage(res.data)
            setLoading(false);
        });
    }, []);

    const getImageUrlById = (imageId) => {
        const image = assetsImage.find(p => p.Id === imageId);
        return image ? image.FileUrl : "";
    };

    return (
        <AssetsImageContext.Provider value={{ assetsImage, loading, getImageUrlById }}>
            {children}
        </AssetsImageContext.Provider>
    );
}

export const useAssetsImage = () => useContext(AssetsImageContext);
